import Vue from 'vue'; 
import Vuex from 'vuex';
import axios from 'axios';
Vue.use(Vuex);
function safeJSONParse(key, defaultValue) {
  try {
    const item = localStorage.getItem(key);
    if (item === null || item === undefined || item === 'undefined') {
      return defaultValue;
    }
    return JSON.parse(item);
  } catch (e) {
    console.error(`Error parsing ${key} from localStorage:`, e);
    return defaultValue;
  }
}
export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    user: safeJSONParse('user', {}),
    menus: safeJSONParse('menus', []),
    entity: safeJSONParse('entity', {}),
    overlay: false,
    success: true,
  },
  mutations: {
    SET_OVERLAY(state, value) {
      state.overlay = value;
    },
    SET_ENTITY(state, entity) {
      state.entity = entity;
    },
    USER_TOKEN(state, token) {
      state.token = token;
    },
    SET_USER(state, user) {
      state.user = user;
    },
    SET_MENUS(state, menus) {
      state.menus = menus;
    },
    USER_LOGOUT(state) {
      state.token = '';
      state.user = {};
      state.menus = [];
      state.entity = {};
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('menus');
      localStorage.removeItem('entity');
    },
  },
  actions: {
    setOverlay({ commit }, value) {
      commit('SET_OVERLAY', value);
    },
    setSuccess({ commit }, data){
      commit('SET_SUCCESS', data)
    },
    setEntity({ commit }, entity) {
      commit('SET_ENTITY', entity);
    },
    loginUser({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${process.env.VUE_APP_URL}/api/login`, data)
          .then(res => {
            const userData = res.data.user;
            const token = res.data.access_token; 
            const menus = res.data.menus; 
            const entity = res.data.entity; 
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
            commit("USER_TOKEN", token);
            commit("SET_USER", userData);
            commit("SET_MENUS", menus); 
            commit("SET_ENTITY", entity); 
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(userData));
            localStorage.setItem('menus', JSON.stringify(menus));
            localStorage.setItem('entity', JSON.stringify(entity));
            resolve(res); 
          })
          .catch(err => {
            reject(err); 
          });
      });
    },
    logoutUser({ commit, getters }) {
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_URL}/api/logout`, null, {
          headers: {
            'Authorization': `Bearer ${getters.isTokenUser}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        })
        .then(res => {
          commit('USER_LOGOUT')
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
      })
    }
  },    
  getters: {
    getMenus: state => state.menus || [],
    getUser:state => state.user,
    isAuth: state => !!state.token,
    isTokenUser: state => state.token,
    getEntity: state => state.entity,
  },
});
